import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import LoginIcon from '@mui/icons-material/Login';
import PersonIcon from '@mui/icons-material/Person';
import { Box, IconButton, Avatar, Button } from '@mui/material';
import LogoSection from './LogoSection';
import { LanguageSelector } from '../common';
import { useAuth } from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

const MobileHeaderTop = ({ 
  onDrawerToggle,
  onLogoClick,
  onProfileMenuOpen,
  onLogin,
  user,
  t,
  isLoggedIn,
  hideLoginButton = false,
  showMenuButton = true  // 햄버거 버튼 표시 여부 제어
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'flex-start',
      position: 'relative',
      width: '100%',
      height: 56,
      px: 1.5,
      py: 0.5,
      minHeight: 40
    }}>
      {/* 햄버거 메뉴 (좌측) - 로그인 상태이고 showMenuButton이 true일 때만 표시 */}
      {isLoggedIn && showMenuButton && (
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={onDrawerToggle}
          sx={{ 
            color: '#666',
            mr: 0.5,
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {/* 로고+텍스트 */}
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <LogoSection 
          onClick={onLogoClick}
          isMobile={true}
          centered={false}
        />
      </Box>

      {/* 언어 선택기 + 프로필/로그인 (우측) */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LanguageSelector />
        {isLoggedIn ? (
          <Avatar
            src={user?.photo}
            onClick={onProfileMenuOpen}
            sx={{
              width: 32,
              height: 32,
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8
              }
            }}
          >
            {!user?.photo && <PersonIcon />}
          </Avatar>
        ) : (
          !hideLoginButton && (
            <IconButton
              onClick={onLogin}
              sx={{
                color: '#1976d2',
                '&:hover': {
                  bgcolor: 'rgba(25, 118, 210, 0.04)'
                }
              }}
            >
              <LoginIcon />
            </IconButton>
          )
        )}
      </Box>
    </Box>
  );
};

export default MobileHeaderTop; 